export default __webpack_public_path__ + "static/media/a016-market-2.a769bf6b.jpg";